import moment from 'moment';
import React, { Fragment, PureComponent, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import GoKids from '../../services/GoKids';
import { readMoney, readPhone } from '../../helpers/format';
import CellStatus from '../../components/CellStatus';
import PageTitle from '../../components/PageTitle';
import Input from '../../components/Input';
import DataFetchPage from '../../components/DataFetchPage';
import { toDay } from '../../helpers/form';
import DriverActionsCell from '../../components/DriverActionsCell';
// import SearchField from "react-search-field";
import Select from 'react-select'
function DriverList () {

    const [dados, setDados] = useState();
    const [dadosDefault, setDadosDefault] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [input, setInput] = useState();
    const [requestCount, setRequestCount] = useState(0);


 
      const options = [
        { value: '', label: 'Todos' },
        { value: 'allowed', label: 'Acesso permitido' },
        { value: 'pending', label: 'Aguardando' },
        { value: 'inreview', label: 'Analisando' },
        { value: 'notallowed', label: 'Recusado' }
      ]

  const columns = [
    {
      Header: 'Mãetorista',
      columns: [
        {
          Header: 'Nome',
          id: 'fullName',
          accessor: d => d.fullName || d.nickname || 'Desconhecido',
          Cell: ({ value, original }) => (
            <React.Fragment>
              <h4>{value}</h4>
              <p>
                Nasc.: {toDay(original.birthday)} · {original.city || '????'}/{original.state || '??'}
              </p>
            </React.Fragment>
          )
        },
        {
          Header: 'E-mail',
          accessor: 'email'
        },
        {
          Header: 'Telefone',
          accessor: 'phone.number',
          Cell: ({ value }) => readPhone(value)
        }
      ]
    },
    {
      Header: 'Data de cadastro',
      className: 'text-center',
      accessor: 'createdAt',
      Cell: ({ value }) => moment(value).format('L LT')
    },
    {
      Header: 'Situação',
      accessor: 'status',
      Cell: CellStatus,
      className: 'text-center'
    },
    {
      Header: 'Último pagamento',
      columns: [
        {
          Header: 'Valor',
          width: 120,
          accessor: 'lastPayment.value',
          Cell: ({ value }) => (value ? readMoney(value) : '')
        },
        {
          Header: 'Data',
          width: 110,
          className: 'text-center',
          accessor: 'lastPayment.date',
          Cell: ({ value }) => (value ? moment(value, 'YYYYMMDD').format('L') : '')
        }
      ]
    },
    {
      width: 92,
      className: 'cell-actions',
      filterable: false,
      sortable: false,
      Cell: ({ original }) => <DriverActionsCell driverId={original._id} />
    }
  ];


  useEffect(() => {
    loadFromApi()
  }, []);

  async function loadFromApi() {
    let drivers = await GoKids.listDrivers()
    console.log(drivers);
    setDados(drivers)
    setDadosDefault(drivers)
    setIsLoading(false)

    let request= await GoKids.countRequests()
    setRequestCount(request || 0 )

    // const [drivers, requestCount] = await Promise.all([GoKids.listDrivers(), GoKids.countRequests()]);
    // return { drivers, requestCount: requestCount || 0 };
  }


  const RenderTopActions = () => (
    <div className="card-top-actions">
        

      <h4>({isLoading ? '...' : dados.length}) mãetoristas registradas</h4>
    {!isLoading && (
        <Button tag={Link} color="link" to="/maetoristas/solicitacoes">
          {requestCount === 0 ? 'Nenhuma solicitação' : `Ver ${requestCount} solicitações`}
        </Button>
      )} 
      <Button tag={Link} color="primary" to="/maetoristas/adicionar">
        Adicionar
      </Button>
    </div>
  );

 const renderContent = ({ isLoading, data }) => (
    <ReactTable loading={isLoading} data={data ? data.drivers : []} columns={DriverList.columns} />
  );


  const updateInput = async (value) => {
    console.log(value)
    const filtered = dadosDefault.filter(country => {
     return country.fullName.toLowerCase().includes(value.toLowerCase())
    })
    setInput(value);
    setDados(filtered);
 }


 const updateSelect = async (value) => {

     console.log(value.value.replace(/\.|\-/g, ''))
    const filtered = dadosDefault.filter(country => {
     return country.status.replace(/\.|\-/g, '') == value.value
    })
  
    setDados(filtered);
 }

 
    return (
      <Fragment>
        <PageTitle title="Mãetoristas">Mãetoristas</PageTitle>
        {/* <DataFetchPage
          className="card card-table"
          fetch={loadFromApi}
          renderToolbar={renderTopActions}
          renderContent={renderContent}
        /> */}
     
     <div className="card card-table">
          <div className="card-top-actions">
         <div style={{float:'left', width:200}} >
        
         <Input  name="nickname" value={input} onChange={(a,b)=> updateInput(b)} />
         {/*  <SearchField
  placeholder="Search..."
  onChange={(q)=> updateInput(q)}
  searchText=""
  classNames="test-class"
  styles={{float:'left'}}
/>*/}
</div>
<div style={{float:'left', width:200, marginLeft:30}} >
<Select options={options} onChange={(d)=> updateSelect(d)}   />
         </div>
         <RenderTopActions />
         </div>
         <div style={{ clear: "both"}}>

         <ReactTable loading={isLoading} data={dados ? dados : []} columns={columns} />
         </div>
         </div>
        
      </Fragment>
    );
  

  
}

DriverList.propTypes = {
  //label: PropTypes.string,
};

const styles = {};

export default DriverList;



// WEBPACK FOOTER //
// ./src/screens/driver/DriverList.js